import { render } from "./GlobalNaviManegmentComponent.vue?vue&type=template&id=9b3d1fa2&scoped=true&ts=true"
import script from "./GlobalNaviManegmentComponent.vue?vue&type=script&lang=ts"
export * from "./GlobalNaviManegmentComponent.vue?vue&type=script&lang=ts"

import "./GlobalNaviManegmentComponent.vue?vue&type=style&index=0&id=9b3d1fa2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b3d1fa2"]])

export default __exports__